module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_02.503f1c66.png";